/* TRrunway - Quick Add to cart */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-trr-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var orig = btn.textContent;
    btn.textContent = '.';
    btn.disabled = true;

    var addUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) throw new Error(data.description || 'Error');
      btn.textContent = 'Added';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function() { btn.textContent = orig; btn.disabled = false; });
  });
})();